import React from "react";
import "./UserTypeSection.css";
import { Link } from "react-router-dom";
import afaziImage from "../../../assets/images/afazi.png";
import doktorImage from "../../../assets/images/doktor.png";
import { FaArrowRight } from "react-icons/fa";

const scrollToTalepFormu = (e) => {
  e.preventDefault();
  const el = document.getElementById("talep-formu");
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

const UserTypeSection = () => {
  return (
    <section className="user-type-section">
      <div className="user-type-row">
        {/* Afazili Kartı */}
        <div className="user-type-card afazili-card">
          <img src={afaziImage} alt="Afazili" className="user-type-img" />
          <div className="user-type-content">
            <h2 className="user-type-title">
              Afazili/Afazi <br />
              Bakımvereni
            </h2>
            <p className="user-type-description">
              Dil ve konuşma bozukluğu sorunu yaşayan afazi tanısı almış veya afazi riski olan kişiler başvuru yapabilir.
            </p>
            <div className="user-type-buttons">
              <a href="#talep-formu" className="btn-contact" onClick={scrollToTalepFormu}>
                İletişime Geç <FaArrowRight className="user-type-arrow-icon" />
              </a>
              <Link to="/iletisim" className="btn-more">
                Daha Fazla Bilgi Al
              </Link>
            </div>
          </div>
        </div>

        {/* Terapist Kartı */}
        <div className="user-type-card doktor-card">
          <div className="user-type-content">
            <h2 className="user-type-title">Terapist/Doktor</h2>
            <p className="user-type-description">
              Nörojenik bozukluklarda dil bozukluğu yaşayan kişilerin terapilerinde ve süreçlerinde aktif görev alan dil ve konuşma terapistleri ve doktorlar başvuru yapabilir.
            </p>
            <div className="user-type-buttons">
              <a href="#talep-formu" className="btn-contact" onClick={scrollToTalepFormu}>
                İletişime Geç <FaArrowRight className="user-type-arrow-icon" />
              </a>
              <Link to="/iletisim" className="btn-more">
                Daha Fazla Bilgi Al
              </Link>
            </div>
          </div>
          <img src={doktorImage} alt="Doktor" className="user-type-img" />
        </div>
      </div>
    </section>
  );
};

export default UserTypeSection;
